import * as yup from 'yup';
import { STRICT_EMAIL_REGEX } from './consts';
import { definePhoneValidator } from './phone';
import { defineHebrewOnlyValidator } from './hebrew-only/hebrew-only';
import { defineEnglishOnlyValidator } from './english-only/english-only';

/** custom validations */
definePhoneValidator();
defineHebrewOnlyValidator();
defineEnglishOnlyValidator();

export { STRICT_EMAIL_REGEX };
export default yup;
